import { HttpService } from "core/services/http";
import HttpServiceClass from "core/services/http";

export class JobHttpService {

    
    static async loadCV(id) {
        var service = new HttpService();
        var response = await service.get(`/job/cv/${id}`, null);
        return response;
    }

  
    static async saveCV(body) {

        var service = new HttpService();
        var response;

        if (body.id) {
            response = await service.put(`/job/cv/${body.id}`, body);
        }
        else
            response = await service.post('/job/cv/', body);

        console.log("response", response);

        return response
    }

    static async loadCVList({page=1,size=30}) {
        var service = new HttpService();
        var response = await service.get(`/job/cv/?page=${page}&size=${size}`, null);
        console.log("response", response);
        return response;
    }

    static async loadCVs() {
        var service = new HttpService();
        var response = await service.get(`/job/cv/`, null);
        return response;
    }

    static async loadCVFiles(id) {
        var service = new HttpService();
        var response = await service.get(`/job/cvfiles/`, {
            responseType: 'blob'
        });
        return response;
    }

    static async saveBenefit(body) {

        var service = new HttpService();
        var response;

        if (body.id) {
            response = await service.put(`/job/benefit/${body.id}`, body);
        }
        else
            response = await service.post('/job/benefit/', body);

        return await response
    }

    static async loadBenefit(id) {
        var service = new HttpService();
        var response = await service.get(`/job/benefit/${id}`, null);
        return response;
    }

    static async loadBenefits(page=1) {
        var service = new HttpService();
        var response = await service.get('/job/benefit/', null);
        return response;
    }

    static async saveSchedule(body) {
        var service = new HttpService();
        var response;

        if (body.id) {
            response = await service.put(`/job/schedule/${body.id}`, body);
        }
        else
            response = await service.post('/job/schedule/', body);

        return await response
    }

    static async loadSchedule(id) {
        var service = new HttpService();
        var response = await service.get(`/job/schedule/${id}`, null);
        return response;
    }

    static async loadSchedules(page=1) {
        var service = new HttpService();
        var response = await service.get('/job/schedule/', null);
        return response;
    }

    static async saveJobType(body) {
        var service = new HttpService();
        var response;

        if (body.id) {
            response = await service.put(`/job/jobtype/${body.id}`, body);
        }
        else
            response = await service.post('/job/jobtype/', body);

        return await response
    }

    static async loadJobType(id) {
        var service = new HttpService();
        var response = await service.get(`/job/jobtype/${id}`, null);
        return response;
    }

    static async loadJobTypes(page=1) {
        var service = new HttpService();
        var response = await service.get('/job/jobtype/', null);
        return response;
    }

    static async saveCategory(body) {
        var service = new HttpService();
        var response;

        if (body.id) {
            response = await service.put(`/job/category/${body.id}`, body);
        }
        else
            response = await service.post('/job/category/', body);

        return await response
    }

    static async loadCategory(id) {
        var service = new HttpService();
        var response = await service.get(`/job/category/${id}`, null);
        return response;
    }

    static async loadCategories(page=1) {
        var service = new HttpService();
        var response = await service.get('/job/category/', null);
        return response;
    }

    static async uploadGalleryImage(file, title = '') {
        const service = new HttpService();
        const formData = new FormData();
        formData.append('image', file);
        if (title) {
            formData.append('title', title);
        }
        const response = await service.post('/job/gallery/', formData, true); // true indicates file upload
        return response;
    }

    static async loadGalleryImages(page = 1, size = 50) {
        const service = new HttpService();
        const response = await service.get(`/job/gallery/?page=${page}&size=${size}`, null);
        return response;
    }

    static async deleteGalleryImage(id) {
        const service = new HttpService();
        const response = await service.delete(`/job/gallery/${id}`);
        return response;
    }

    static async loadJob(id) {
        const service = new HttpService();
        const response = await service.get(`/job/${id}`, null);
        return response;
    }

    static async createJob(body) {
        const service = new HttpService();
        const response = await service.post('/job/', body);
        return response;
    }

    static async updateJob(id, body) {
        const service = new HttpService();
        const response = await service.put(`/job/${id}`, body);
        return response;
    }

    static async partialUpdateJob(id, body) {
        const service = new HttpService();
        const response = await service.patch(`/job/${id}`, body);
        return response;
    }

    static async loadJobs({ page = 1, size = 30, filters = {} } = {}) {
        const service = new HttpService();
        const params = Object.entries({ page, size, ...filters })
            .filter(([, value]) => value !== undefined && value !== null && value !== '')
            .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
        const response = await service.get('/job/', params);
        return response;
    }

    static async loadJobApplications({ jobId, page = 1, size = 100 } = {}) {
        const service = new HttpService();
        const params = {
            page,
            size
        };

        if (jobId) {
            params.job = jobId;
        }

        const response = await service.get('/job/apply/', params);
        return response;
    }

    static async loadEmployerApplications({ page = 1, size = 100 } = {}) {
        const service = new HttpService();
        const params = {
            page,
            size
        };

        // Returns applications for jobs owned by the authenticated employer
        const response = await service.get('/job/application/', params);
        return response;
    }

    static async loadApplication(id) {
        const service = new HttpService();
        const response = await service.get(`/job/apply/${id}`, null);
        return response;
    }

    static async updateApplication(id, body) {
        const service = new HttpService();
        const response = await service.put(`/job/apply/${id}`, body);
        return response;
    }

    static async deleteApplication(id) {
        const service = new HttpService();
        const response = await service.delete(`/job/apply/${id}`);
        return response;
    }

    static async loadCompany(id) {
        const service = new HttpService();
        const response = await service.get(`/job/company/${id}`, null);
        return response;
    }

    static async updateCompany(id, body) {
        const service = new HttpService();
        const response = await service.put(`/job/company/${id}`, body);
        return response;
    }

    static async loadCompanies({ page = 1, size = 30, filters = {} } = {}) {
        const service = new HttpService();
        const params = Object.entries({ page, size, ...filters })
            .filter(([, value]) => value !== undefined && value !== null && value !== '')
            .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
        const response = await service.get('/job/company/', params);
        return response;
    }

    static async loadMyCompany() {
        const service = new HttpService();
        const response = await service.get('/job/company/?me=1', null);
        // Return first company if array, or the company object itself
        if (Array.isArray(response)) {
            return response.length > 0 ? response[0] : null;
        }
        if (response?.results && Array.isArray(response.results)) {
            return response.results.length > 0 ? response.results[0] : null;
        }
        return response || null;
    }

    static async createCompany(body) {
        const service = new HttpService();
        const response = await service.post('/job/company/', body);
        return response;
    }

    static async saveCompany(body) {
        const service = new HttpService();
        let response;
        if (body.id) {
            response = await service.put(`/job/company/${body.id}`, body);
        } else {
            response = await service.post('/job/company/', body);
        }
        return response;
    }

    static async loadCandidates({ page = 1, size = 30, filters = {} } = {}) {
        const service = new HttpService();
        const params = {
            page,
            size,
            ...filters
        };
        const response = await service.get('/job/jobseekers/', params);
        return response;
    }

    static async loadCandidate(id) {
        const service = new HttpService();
        const response = await service.get(`/job/jobseekers/${id}`, {
            include: 'experiences,education'
        });
        return response;
    }

    // Employee methods
    static async loadEmployees({ company, page = 1, size = 100 } = {}) {
        const service = new HttpService();
        const params = { page, size };
        if (company) {
            params.company = company;
        }
        const response = await service.get('/job/companyemployee/', params);
        return response;
    }

    static async loadEmployee(id) {
        const service = new HttpService();
        const response = await service.get(`/job/companyemployee/${id}`, null);
        return response;
    }

    static async createEmployee(body) {
        const service = new HttpService();
        const response = await service.post('/job/companyemployee/', body);
        return response;
    }

    static async updateEmployee(id, body) {
        const service = new HttpService();
        const response = await service.put(`/job/companyemployee/${id}`, body);
        return response;
    }

    static async deleteEmployee(id) {
        const service = new HttpService();
        const response = await service.delete(`/job/companyemployee/${id}`);
        return response;
    }

    // Salary Specification methods
    static async loadSalarySpecifications({ company, page = 1, size = 100 } = {}) {
        const service = new HttpService();
        const params = { page, size };
        if (company) {
            params.company = company;
        }
        const response = await service.get('/job/salaryspecification/', params);
        return response;
    }

    static async loadSalarySpecification(id) {
        const service = new HttpService();
        const response = await service.get(`/job/salaryspecification/${id}`, null);
        return response;
    }

    static async createSalarySpecification(body) {
        const service = new HttpService();
        const response = await service.post('/job/salaryspecification/', body);
        return response;
    }

    static async updateSalarySpecification(id, body) {
        const service = new HttpService();
        const response = await service.put(`/job/salaryspecification/${id}`, body);
        return response;
    }

    static async deleteSalarySpecification(id) {
        const service = new HttpService();
        const response = await service.delete(`/job/salaryspecification/${id}`);
        return response;
    }

    static async generateSalarySpecificationPdf(id) {
        const headers = new Headers();
        headers.append("Accept", "application/pdf");
        const auth = HttpService.getToken();
        if (auth) {
            headers.append("Authorization", "Bearer " + auth);
        }

        const fullUrl = `${HttpService.ApiBase}/job/salaryspecification/${id}/generate-report/`;
        
        const response = await fetch(fullUrl, {
            headers: headers,
            method: 'GET',
        });

        if (!response.ok) {
            throw new Error('Failed to download PDF');
        }

        const blob = await response.blob();
        return blob;
    }

    // Deductions Contributions methods
    static async loadDeductionsContributions({ salary_specification } = {}) {
        const service = new HttpService();
        const params = {};
        if (salary_specification) {
            params.salary_specification = salary_specification;
        }
        const response = await service.get('/job/deductionscontributions/', params);
        return response;
    }

    static async loadDeductionContribution(id) {
        const service = new HttpService();
        const response = await service.get(`/job/deductionscontributions/${id}`, null);
        return response;
    }

    static async createDeductionContribution(body) {
        const service = new HttpService();
        const response = await service.post('/job/deductionscontributions/', body);
        return response;
    }

    static async updateDeductionContribution(id, body) {
        const service = new HttpService();
        const response = await service.put(`/job/deductionscontributions/${id}`, body);
        return response;
    }

    // Salary Detail methods
    static async loadSalaryDetails({ salary_specification, page = 1, size = 100 } = {}) {
        const service = new HttpService();
        const params = { page, size };
        if (salary_specification) {
            params.salary_specification = salary_specification;
        }
        const response = await service.get('/job/salarydetail/', params);
        return response;
    }

    static async loadSalaryDetail(id) {
        const service = new HttpService();
        const response = await service.get(`/job/salarydetail/${id}`, null);
        return response;
    }

    static async createSalaryDetail(body) {
        const service = new HttpService();
        const response = await service.post('/job/salarydetail/', body);
        return response;
    }

    static async updateSalaryDetail(id, body) {
        const service = new HttpService();
        const response = await service.put(`/job/salarydetail/${id}`, body);
        return response;
    }

    static async deleteSalaryDetail(id) {
        const service = new HttpService();
        const response = await service.delete(`/job/salarydetail/${id}`);
        return response;
    }

    // Invoice methods
    static async loadInvoices({ company, page = 1, size = 100 } = {}) {
        const service = new HttpService();
        const params = { page, size };
        if (company) {
            params.company = company;
        }
        const response = await service.get('/job/invoice/', params);
        return response;
    }

    static async loadInvoice(id) {
        const service = new HttpService();
        const response = await service.get(`/job/invoice/${id}`, null);
        return response;
    }

    static async createInvoice(body) {
        const service = new HttpService();
        const response = await service.post('/job/invoice/', body);
        return response;
    }

    static async updateInvoice(id, body) {
        const service = new HttpService();
        const response = await service.put(`/job/invoice/${id}`, body);
        return response;
    }

    static async deleteInvoice(id) {
        const service = new HttpService();
        const response = await service.delete(`/job/invoice/${id}`);
        return response;
    }

    static async generateInvoicePdf(id) {
        const headers = new Headers();
        headers.append("Accept", "application/pdf");
        const auth = HttpService.getToken();
        if (auth) {
            headers.append("Authorization", "Bearer " + auth);
        }

        const fullUrl = `${HttpService.ApiBase}/job/invoice/${id}/generate-report/`;
        
        const response = await fetch(fullUrl, {
            headers: headers,
            method: 'GET',
        });

        if (!response.ok) {
            throw new Error('Failed to download PDF');
        }

        const blob = await response.blob();
        return blob;
    }

    // Contract methods
    static async loadContracts({ company, page = 1, size = 100 } = {}) {
        const service = new HttpService();
        const params = { page, size };
        if (company) {
            params.company = company;
        }
        const response = await service.get('/job/contract/', params);
        return response;
    }

    static async loadContract(id) {
        const service = new HttpService();
        const response = await service.get(`/job/contract/${id}`, null);
        return response;
    }

    static async createContract(body) {
        const service = new HttpService();
        const response = await service.post('/job/contract/', body);
        return response;
    }

    static async updateContract(id, body) {
        const service = new HttpService();
        const response = await service.put(`/job/contract/${id}`, body);
        return response;
    }

    static async deleteContract(id) {
        const service = new HttpService();
        const response = await service.delete(`/job/contract/${id}`);
        return response;
    }

    static async generateContractPdf(id) {
        const headers = new Headers();
        headers.append("Accept", "application/pdf");
        const auth = HttpService.getToken();
        if (auth) {
            headers.append("Authorization", "Bearer " + auth);
        }

        const fullUrl = `${HttpService.ApiBase}/job/contract/${id}/generate-report/`;
        
        const response = await fetch(fullUrl, {
            headers: headers,
            method: 'GET',
        });

        if (!response.ok) {
            throw new Error('Failed to download PDF');
        }

        const blob = await response.blob();
        return blob;
    }
   
}

